import * as Yup from "yup";
import { useState } from 'react';
import './SetPriceAlertModal.scss';
import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../common/Button/Button';
import Modal from '../../../../common/Modals/Modal/Modal';
import Select from '../../../../common/Formik/Select/Select';
import Textarea from '../../../../common/Formik/Textarea/Textarea';
import InputFormik from '../../../../common/Formik/Input/InputFormik';
import { setPriceAlertAction } from '../../../../../features/user/userSlice';

const SetPriceAlertModal = ({ show, handleClose }) => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isModify, setIsModify] = useState(false);
    const spotPrice = useSelector((state) => state?.users?.spotPrice);

    const alertOptions = [
        { value: "GT", label: "Greater than equal to" },
        { value: "LT", label: "Less than equal to" },
    ];
    const typesOptions = [
        { value: "GOLD", label: "Gold" },
        { value: "SILVER", label: "Silver" },
    ];

    const priceAlertSchema = Yup.object().shape({
        alert: Yup.string().required("Alert type is required"),
        types: Yup.string().required("Metal type is required"),
        amount: Yup.number()
            .typeError("Amount must be a valid number")
            .required("Amount is required")
            .min(1, "Amount must be greater than 0"),
        notes: Yup.string().max(140, "Note cannot exceed 140 characters"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            alert: "",
            types: "GOLD",
            amount: "",
            notes: "",
        },
        validationSchema: priceAlertSchema,
        onSubmit: async (values) => {
            setLoading(true)
            try {
                const payload = {
                    price_alert: [{
                        "metal_type": values?.types,
                        "target_price": values?.amount,
                        "condition": values?.alert
                    }]
                }
                const res = await dispatch(setPriceAlertAction(payload))
                if (res?.data?.status === 200 || res?.data?.status === 201) {
                    handleClose()
                    formik.resetForm();
                }
            } catch (error) {
                console.log(error, "ERROR");
            } finally {
                setLoading(false)
            }
        }
    });

    const pricelisting = [
        { label: "Alert Me", value: formik.values.alert },
        { label: "Metal Type", value: formik.values.types },
        { label: "Value", value: formik.values.amount },
        { label: "Note", value: formik.values.notes },
    ];
    const priceList = [
        { label: formik.values.types + " Price :", value: formik.values.types === "GOLD" ? spotPrice?.goldPrice : spotPrice?.silverPrice },
    ];
    return (
        <Modal
            show={show}
            handleClose={handleClose}
            className="setPrice"
            title='Set Price Alert'
        >
            <div className='setPrice_innerSec'>
                <ul className='setpricelist'>
                    {priceList.map((items, index) => (
                        <li className={`listcard ${items.className || ''}`} key={index}>
                            <label>{items.label}</label>
                            <h6>{items.value}</h6>
                        </li>
                    ))}
                </ul>

                {isModify ? (
                    <div className='pricealertmodify'>
                        <ul className='modifylist'>
                            {pricelisting.map((items, index) => (
                                <li key={index}>
                                    <label>{items.label}</label>
                                    <h6>{items.value}</h6>
                                </li>
                            ))}
                        </ul>
                        <div className='pricealertmodify_btnSec'>
                            <Button fluid className="btnSetalert" onClick={() => setIsModify(false)}>
                                Modify Alert
                            </Button>
                            <Button
                                fluid
                                variant='danger_filled'
                                className="btnSetalert"
    onClick={() => {}}
                            >
                                Set Alert
                            </Button>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <div className='setpriceform'>
                            <div className="inner_select">
                                <Select
                                    variant='xlarge_height'
                                    className='select_time'
                                    label="Select Asset"
                                    options={typesOptions}
                                    isSearchable={false}
                                    name="types"
                                    defaultValue={{ value: "GOLD", label: "Gold" }}
                                    value={typesOptions.find(op => op.value === formik.values.types)}
                                    onChange={(val) => formik.setFieldValue("types", val.value)}
                                />
                                {formik.touched.types && formik.errors.types && (
                                    <span className="error" style={{ color: "red" }}>{formik.errors.types}</span>
                                )}
                            </div>

                            <div className="inner_select">
                                <Select
                                    variant='xlarge_height'
                                    className='select_time'
                                    label="Alert Me"
                                    options={alertOptions}
                                    isSearchable={false}
                                    name="alert"
                                    value={alertOptions.find(op => op.value === formik.values.alert)}
                                    onChange={(val) => formik.setFieldValue("alert", val.value)}
                                />
                                {formik.touched.alert && formik.errors.alert && (
                                    <span className="error" style={{ color: "red" }}>{formik.errors.alert}</span>
                                )}
                            </div>

                            <div className="inputfield">
                                <InputFormik
                                    variant='large_height'
                                    label="Amount"
                                    placeholder="Enter Amount"
                                    name="amount"
                                    value={formik.values.amount}
                                    onChange={formik.handleChange}
                                />
                                {formik.touched.amount && formik.errors.amount && (
                                    <span className="error" style={{ color: "red" }}>{formik.errors.amount}</span>
                                )}
                            </div>

                            <div className="textareafield">
                                <Textarea
                                    variant='large_height'
                                    rows={5}
                                    label={
                                        <div className='textarea_label'>
                                            <p>Add Note</p>
                                            <div className='character'>
                                                <span>Remaining Characters: </span>
                                                {formik.values.notes.length}/140
                                            </div>
                                        </div>
                                    }
                                    placeholder="Enter note"
                                    name="notes"
                                    value={formik.values.notes}
                                    onChange={formik.handleChange}
                                />
                                {formik.touched.notes && formik.errors.notes && (
                                    <span className="error" style={{ color: "red" }}>{formik.errors.notes}</span>
                                )}
                            </div>

                            <Button
                                type="button"
                                fluid
                                className="btnSetalert"
                                disabled={loading}
                                onClick={(e) => {
                                    formik.handleSubmit(e);
                                }}
                            >
                                Set Alert
                            </Button>
                        </div>
                    </form>
                )}
            </div>
        </Modal>
    );
};

export default SetPriceAlertModal;
